import i18n from 'i18next';

import { ENV_VARS } from '@/env';
import { authService, logOut } from '@/modules/auth';
import { getSelectedCompanyId } from '@/utils/user';
import { NOTIFICATION_TYPES, showNotification } from '@/views/components/Modals/notification';

export function ExpireTokenInterceptor(response) {
  const requestId = response?.response?.headers?.['x-api-requestid'];

  // biome-ignore lint/style/noMagicNumbers: unauthorized
  if (response?.response?.status === 401) {
    showNotification({
      message: i18n.t('translation:default.notification.sessionExpired'),
      requestId,
      type: NOTIFICATION_TYPES.ERROR,
    });
    logOut();
    return Promise.reject(response);
  }

  if (response?.code === 'ERR_CANCELED') {
    return Promise.resolve({ status: 499 });
  }

  return Promise.reject(response);
}

export async function setTokenInterceptor(config) {
  if (authService.accessToken) {
    config.headers.Authorization = `Bearer ${authService.accessToken}`;
  }
  return config;
}

export async function addCompanyIdInterceptor(config) {
  const selectedCompanyId = getSelectedCompanyId();

  if (selectedCompanyId) {
    config.headers['X-Company-Id'] = selectedCompanyId;
  }

  return config;
}

export function obsoleteEndpointInterceptor(response) {
  if (!ENV_VARS.REACT_APP_LOG_OBSOLETE_ENDPOINTS) {
    return response;
  }

  const headers = response?.headers;
  const obsoleteHeader = headers?.['x-obsolete-endpoint'];

  if (obsoleteHeader) {
    const url = response?.config?.url;
    const method = response?.config?.method?.toUpperCase();

    console.warn('[OBSOLETE ENDPOINT USED]', {
      headerValue: obsoleteHeader,
      method,
      url,
    });
  }

  return response;
}
